// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Nodata
 */
export interface Nodata {}

/**
 * Check if a given object implements the Nodata interface.
 */
export function instanceOfNodata(value: object): value is Nodata {
  return true;
}

export function NodataFromJSON(json: any): Nodata {
  return NodataFromJSONTyped(json, false);
}

export function NodataFromJSONTyped(json: any, ignoreDiscriminator: boolean): Nodata {
  return json;
}

export function NodataToJSON(json: any): Nodata {
  return NodataToJSONTyped(json, false);
}

export function NodataToJSONTyped(
  value?: Nodata | null,
  ignoreDiscriminator: boolean = false
): any {
  return value;
}
